/* Check if the variant is set in the URL, if not, reset the variant picker and buy-buttons and paint calculator button */
/* Plus legacy code for changing main page content based on surface of current variant */

document.addEventListener('DOMContentLoaded', function() {

  const paintGridPicker = document.querySelector('variant-picker[data-paint-grid-mode]');

  if (paintGridPicker) {
    // Hide price for paint products using the size grid picker
    const atcButton = document.querySelector(
      'buy-buttons .paint-grid-buy-actions > button.button:not(.paint-calculator-button)'
    );
    if (atcButton) {
      atcButton.style.transitionProperty = 'none';
      atcButton.disabled = true;
    }

    const pricelist = document.querySelector('.product-info__block-item[data-block-type="price"]');
    if (pricelist) pricelist.style.display = 'none';

  } else {
    // For standard products (swatches, sample tins, tools): reveal the price by removing the 'hidden' class
    const priceBlock = document.querySelector('.product-info__block-item[data-block-type="price"]');
    if (priceBlock) {
      priceBlock.style.display = '';
      const hiddenChild = priceBlock.querySelector('.hidden');
      if (hiddenChild) {
        hiddenChild.classList.remove('hidden');
      }
    }

    // Handle variant parameter logic for non-grid products
    const paintVariantsData = document.querySelector('script[type="application/json"][id="paint-variants-data"]');
    if (paintVariantsData) {
      const urlParams = new URLSearchParams(window.location.search);
      const variant = urlParams.get('variant');
      if (!variant) {
        const atcbutton = document.querySelector('buy-buttons button[type="submit"]');
        if (atcbutton) {
          atcbutton.style.transitionProperty = 'none';
          atcbutton.disabled = true;
        }
        const paintCalcButton = document.querySelector('button.paint-calculator-button');
        if (paintCalcButton) paintCalcButton.style.display = 'none';
      }
    }
  }



  const infoSections = {
    'defaultinfo': document.querySelectorAll('.defaultinfo'),
    'interior-walls-and-ceilings': document.querySelectorAll('.interior'),
    'doors-skirtings-and-trims': document.querySelectorAll('.trims'),
    'radiator': document.querySelectorAll('.radiator'),
    'cot-and-furniture': document.querySelectorAll('.furniture'),
    'kitchen-and-bathroom': document.querySelectorAll('.kitbat'),
    'exterior-masonry': document.querySelectorAll('.masonry'),
    'exterior-wood': document.querySelectorAll('.wood'),
    'exterior-metal': document.querySelectorAll('.metal')
  };


  function hideAllInfoSections() {
    for (const key in infoSections) {
      if (infoSections[key] instanceof NodeList) {
        infoSections[key].forEach(element => {
          if (element) {
            element.style.display = 'none';
          }
        });
      } else if (infoSections[key] && infoSections[key].style) {
        infoSections[key].style.display = 'none';
      }
    }
  }

  function showMatchingSection(selectedValue) {
    const targetClass = selectedValue ? selectedValue.toLowerCase().replace(/ /g, '-').replace(/,/g, '') : null;
    if (targetClass && infoSections[targetClass]) {
      if (infoSections[targetClass] instanceof NodeList) {
        infoSections[targetClass].forEach(element => {
          element.style.display = 'block';
        });
      } else if (infoSections[targetClass].style) {
        infoSections[targetClass].style.display = 'block';
      }
    }
  }

  function getSelectedSurfaceText(radioElement) {
    if (radioElement) {
      const labelElement = radioElement.closest('.popover__value-option');
      if (labelElement) {
        const spanElement = labelElement.querySelector('span');
        if (spanElement) {
          return spanElement.textContent;
        }
      }
    }
    return '';
  }

  // Surface info sections only apply when the product has a Surface option
  let variantRadioSelector = 'input[name$="__main-option1"]';
  if (paintGridPicker) {
    if (!paintGridPicker.hasAttribute('data-paint-surface-index')) {
      variantRadioSelector = null;
    } else {
      const surfaceOptionPosition = parseInt(paintGridPicker.getAttribute('data-paint-surface-index'), 10) + 1;
      variantRadioSelector = 'input[name$="__main-option' + surfaceOptionPosition + '"]';
    }
  }

  if (variantRadioSelector) {
    hideAllInfoSections();

    const initialCheckedRadio = document.querySelector(`${variantRadioSelector}:checked`);

    if (initialCheckedRadio) {
      showMatchingSection(getSelectedSurfaceText(initialCheckedRadio).toLowerCase().replace(/,/g, ''));
    }

    document.addEventListener('change', function(event) {
      if (event.target && event.target.matches(variantRadioSelector)) {
        const selectedText = getSelectedSurfaceText(event.target);
        hideAllInfoSections();
        showMatchingSection(selectedText.toLowerCase().replace(/,/g, ''));
      }
    });
  }
});
